import { createSlice } from "@reduxjs/toolkit";
import { getAllLocations, searchCities, searchLocation } from "../../../thunks/authThunk";
import { message } from "antd";

const initialState = {
  isLoading: false,
  locationDma: null,
  locationDmaList: null,
  error: null,
  allLocations: null,
  // if you have a status, you can store "idle", "loading", "success", "failed"
};

export const searchLocationSlice = createSlice({
  name: "searchlocation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(searchLocation.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(searchLocation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.locationDma = action.payload;
      })
      .addCase(searchLocation.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    builder 
      .addCase(searchCities.pending, (state) =>{
        state.isLoading = true;
        state.error = null;
      })
      .addCase(searchCities.fulfilled, (state,action) =>{
        state.isLoading = false;
        state.citiesList = action.payload;
      })
      .addCase(searchCities.rejected, (state,action) =>{
        state.isLoading = false;
        state.error = action.payload;
      })
    builder
      .addCase(getAllLocations.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAllLocations.fulfilled, (state, action) => {
        state.isLoading = false;
        state.allLocations = action.payload;
      })
      .addCase(getAllLocations.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });
  },
});

export default searchLocationSlice.reducer;
